import _size from 'lodash/size';
import { cleanStringCase } from 'shared/helpers/formatHelpers';

export function updateAppHeaders(addOn?: string | null) {
  document.title = `Klearly${
    _size(addOn) > 0 ? ` - ${cleanStringCase(addOn!)}` : ''
  }`;
}
